import React from 'react';
import { PropTypes } from 'prop-types';

const FaqHeader = ({ header, icon }) => (
  <h2 className="flex middle">
    <div className="margin-lg-right flex">{icon}</div>
    <div style={{ paddingTop: '4px' }}>{header}</div>
  </h2>
);

FaqHeader.propTypes = {
  header: PropTypes.string,
  icon: PropTypes.element
};
export default FaqHeader;
